import { chatbotService } from '../../services/ChatbotService';

export function downloadChatbotLogo(
  chatbotId: string,
): Promise<Blob | null | undefined> {
  return chatbotService.downloadChatbotLogo(chatbotId);
}
